import { CForm } from '@coreui/react-pro'
import React from 'react'

const ConfiaCarForm = (props) => {
  const { children } = props
  return <CForm {...props}>{children}</CForm>
}

export { ConfiaCarForm }
